module.exports = __webpack_public_path__ + "img/elm-b.37073429.png";